import {mock} from './index';

export default {
  createAppShortcut: () => mock('/admin/shortcut/create'),
  deleteShortcut: () => mock('/admin/shortcut/delete'),
  modifyShortcut: () => mock('/admin/shortcut/modify'),
  getAppCategory: () => mock('/admin/shortcut/app/category/list'),
  getShortcut: () => mock('/admin/shortcut/get'),
  getMenu: () => mock('/admin/shortcut/menu/get'),
  getShortcutAppMenuUnAssignedList: () => mock('/admin/shortcut/app/menu/unAssigned'),
  shortcutAppAssign: () => mock('/admin/shortcut/menu/assign'),
  addFirstClassMenu: () => mock('/admin/shortcut/menu/create'),
  deleteMenu: () => mock('/admin/shortcut/menu/delete'),
  modifyMenu: () => mock('/admin/shortcut/menu/modify'),
  sortShortcutMenu: () => mock('/admin/shortcut/menu/sort'),
  getShortcutAppPer: () => mock('/admin/shortcut/permission/get'),
  deletePer: () => mock('/admin/shortcut/permission/delete'),
  getAppPermissionList: () => mock('/admin/shortcut/app/permission/unAssigned'),
  assignShortcutPermission: () => mock('/admin/shortcut/permission/assign')
};
